import classNames from 'classnames';
import { OpinionItemList } from 'components/Opinion/OpinionItemList';
import { Stock } from 'components/Stock/Stock.helper';
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useOutletContext, useParams } from 'react-router-dom';

export const OpinionUpDownPage = () => {
  const { stock } = useOutletContext<{ stock: Stock }>();
  const { tab } = useParams();
  return (
    <Row>
      <Col xs={12} lg={6} className={classNames('d-lg-block', tab === 'up' ? 'd-block' : 'd-none')}>
        <OpinionItemList stock={stock} direction="up" />
      </Col>
      <Col xs={12} lg={6} className={classNames('d-lg-block', tab === 'down' ? 'd-block' : 'd-none')}>
        <OpinionItemList stock={stock} direction="down" />
      </Col>
    </Row>
  );
};
